import React, { useEffect, useState } from "react";

// Import SCSS
import "./assets/scss/themes.scss";
import "./custom.css";

// Import Route
import Route from "./Routes";

// Import Redux
import { setModalCallback } from "./common/sessionManager";
import SassionWarningModal from "./Components/Common/sassionWarningModal";

function App() {
    const [showModal, setShowModal] = useState(false);

  useEffect(() => {
        setModalCallback(setShowModal);
  }, []);

  return (
    <React.Fragment>
      <Route />
      <SassionWarningModal show={showModal} onClose={() => {setShowModal(false)}}  />

    </React.Fragment>
  );
}

export default App;
